module.exports = "<div ui-view=main></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/settings/timezones/timezones.html
// module id = 481
// module chunks = 0